// import { getApiEndpoint } from './apiConfig';
import { toast } from 'react-toastify';
// import { useTranslation } from 'react-i18next';
import i18next from 'i18next';

/**
 * Handles 401 Unauthorized errors by redirecting to login
 * Saves current URL for redirect back after login
 * @param {Error} error - The error object from axios
 * @param {string} [customRedirect] - Optional custom redirect URL after login
 * @returns {Promise} - Rejected promise with the error
 */
export const handleAuthError = (error, customRedirect) => {
  // Check if this is a 401 error
  if (error.response && error.response.status === 401) {
    console.log('401 Unauthorized error detected, checking bypass flags');
    
    // Check for auth bypass flags
    const skipLoginCheck = localStorage.getItem('skipLoginCheck') === 'true' || 
                          sessionStorage.getItem('skipLoginCheck') === 'true';
    const bypassAuth = localStorage.getItem('bypassAuth') === 'true' || 
                      sessionStorage.getItem('bypassAuth') === 'true';
    const noAuthRequired = localStorage.getItem('noAuthRequired') === 'true' || 
                          sessionStorage.getItem('noAuthRequired') === 'true';
    
    // Check if we're on the maintenance page
    const isMaintenancePage = window.location.pathname.includes('/maintenance');
    const isMaterialPage = window.location.pathname.includes('/material');
    const isRepairmenPage = window.location.pathname.includes('/repairmen');
    
    // If any bypass flag is set or we're on maintenance/material/repairmen page, don't redirect
    if (skipLoginCheck || bypassAuth || noAuthRequired || isMaintenancePage || isMaterialPage || isRepairmenPage) {
      console.log('Auth bypass flag detected, not redirecting to login');
      return Promise.reject(error);
    }
    
    // Store the current URL or custom redirect
    const currentPath = customRedirect || window.location.pathname + window.location.search;
    sessionStorage.setItem('returnToUrl', currentPath);
    
    // Clear auth data
    localStorage.removeItem('token');
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    
    // Show toast notification
    toast.error(i18next.t('toastify.1'), {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
    });

    // Redirect to login after a short delay to allow toast to be seen
    setTimeout(() => {
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }, 1500);
  }
  
  // Always return a rejected promise with the original error
  return Promise.reject(error);
}; 